import React, {Component} from 'react';

class Vis extends Component {
  constructor(){
    super();
    this.state = {
      priority: null
    }
  }

  
  changePriority = (p, event) => {
    p++
    if (p > 3) {
      p = 0;
    }
    this.setState({priority: p})
    this.props.changeP(p);
  }
  render(){
    let priorities = ["", "low", "medium", "high"];
    let {abr} = this.props;
    let priority = 0;
    if (this.state.priority === null) {
      priority = this.props.priority;
    } else {
      priority = this.state.priority
    }
    return (
      <div 
        className={`visual vistablero ${priorities[priority]}`}
        onClick={() => this.changePriority(priority)}>
        {abr}
      </div>
    )
  }
  
}

export default Vis;


// WEBPACK FOOTER //
// ./src/Components/Boards/Vis.js